// src/components/forms/formSteps/CompletedStep.tsx
import React from "react";
import { Box, Typography } from "@mui/material";

const CompletedStep: React.FC = () => {
  return (
    <Box sx={{ textAlign: "center" }}>
      <Typography variant="h5" sx={{ mb: 3, color: "green" }}>
        Thank You!
      </Typography>
      <Typography variant="body1" sx={{ mb: 4 }}>
        Your assessment has been submitted successfully. A legal representative
        will contact you shortly to discuss your case.
      </Typography>
    </Box>
  );
};

export default CompletedStep;
